























































	import { Component,Vue,Prop } from 'vue-property-decorator'

	@Component
	export default class AddUser extends Vue{
        @Prop({
            type: Array,
            default: []
        })
		list:any
		@Prop({
            type: Object,
            default: null
        })
		pager:any
		@Prop({
            type: Array,
            default: []
        })
		column:any
		@Prop({
            type: String,
            default: 'selection'
        })
		type:any
		@Prop({
            type: Boolean,
            default: false
        })
		selection:any
		@Prop({
            type: Boolean,
            default: false
        })
		border:any
		@Prop({
            type: Boolean,
            default: false
        })
		showSummary:any
		@Prop({
			type: Array,
			default:() => [20, 50, 500, 1000, 2000, 3000, 4000, 5000, 10000],
		})
		pageSizes:Array
		multipleSelection = []
		get height(){
			return document.body.offsetHeight - 254;
		}
		handleSelectionChange(val:any) {
			this.multipleSelection = val;
			this.$emit('multiplechange',val)
		}
		clear(){
			this.multipleSelection = [];
		}
		tableRowClassName ({row, rowIndex}:any) {
	       //把每一行的索引放进row
	       row.index = rowIndex;
	     }
		pagechange(page:any){
			this.$emit('pagechange',[{ key: 'page', val: page }])
		}
		// 每页条数改变
		handleSizeChange(e:any){
			console.log(e);
			this.$emit('pageSizechange',[{ key: 'pageSize', val: e }])
		}
	}
